import {
  useState,
  useEffect,
  useCallback,
} from "react";
import api from "api/axios";
import { Routes, Route } from "react-router-dom";
import OnboardingPage from "views/onboarding/OnboardingPage";
import Loader from "components/Loader";

export const OnBoardingProvider = ({ children }: { children: React.ReactNode }) => {
  const isLocalDeployment = process.env.REACT_APP_ENTERPRISE === 'true';

  const [isActivated, setIsActivated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  const getActivationStatus = useCallback(async () => {
    try {
      const response = await api.get("/subscriptions/activation-status");
      setIsActivated(response.data.is_activated);
    } catch (err) {
      console.error("Failed to get activation status:", err);
      setIsActivated(false);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (isLocalDeployment) {
      getActivationStatus();
    } else {
      setIsLoading(false);
    }
  }, [getActivationStatus, isLocalDeployment]);

  if (isLoading) {
    return (
      <Loader
        txt="Loading..."
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
      />
    );
  }

  if (isLocalDeployment && !isActivated) {
    return (
      <Routes>
        <Route path="/" element={<OnboardingPage />} />
      </Routes>
    );
  }

  return <>{children}</>;
};


